import React, { useState } from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Necesito experiencia previa?',
  a: 'No, es para cualquier persona.'
}, {
  q: '¿Cuándo veo resultados?',
  a: 'Desde los primeros días aplicando el contenido.'
}, {
  q: '¿Es práctico o teórico?',
  a: '100% práctico. Aplicás y ves resultados.'
}, {
  q: '¿Reemplaza terapia?',
  a: 'No, es un complemento poderoso.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(null);
  return <AnimatedSection className="bg-navy text-white py-12 md:py-16" data-id="element-42">
      <h2 className="text-2xl md:text-3xl font-heading font-bold text-center mb-8" data-id="element-43">
        Preguntas Frecuentes
      </h2>

      <div className="max-w-2xl mx-auto space-y-3" data-id="element-44">
        {faqs.map((faq, idx) => <button key={idx} onClick={() => setOpen(open === idx ? null : idx)} className="w-full bg-navy-light rounded-xl p-5 text-left border border-navy-light hover:border-orange/30 transition-colors" data-id="element-45">
            <div className="flex items-center justify-between gap-4" data-id="element-46">
              <span className="font-bold text-sm md:text-base" data-id="element-47">{faq.q}</span>
              <ChevronDown size={18} className={`text-orange shrink-0 transition-transform duration-200 ${open === idx ? 'rotate-180' : ''}`} data-id="element-48" />
            </div>
            <AnimatePresence data-id="element-49">
              {open === idx && <motion.p initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.2
          }} className="text-gray-400 text-sm mt-3 overflow-hidden" data-id="element-50">
                  {faq.a}
                </motion.p>}
            </AnimatePresence>
          </button>)}
      </div>
    </AnimatedSection>;
}